import store from '@/state/store';
import { create } from '@/api/project';
import projectSlice from '@/state/project.slice';
import { handleError } from '@/actions/common';
import { ProjectCreationData } from '@bimdata/definitions/dto';

export default async (data: ProjectCreationData): Promise<string | null> => {
  try {
    const p = await create(data);
    store.dispatch(projectSlice.actions.created(p));
    return p.code;
  } catch (error) {
    handleError(error);
  }
  return null;
};
